import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useEffect } from 'react';
import { shape, node, func, bool, oneOf, string, number } from 'prop-types';
import { Close } from '@magalu/stereo-ui-icons';
import Portal from '../Portal';
import { Container, Overlay, Paper, Header, Title, CloseComponent, ContentHeader, HorizontalRule } from './dialog.styles';

const withPortal = children => /*#__PURE__*/React.createElement(Portal, {
  id: "portal-dialog"
}, children);

const DialogComp = _ref => {
  let {
    portal = false
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["portal"]);

  const Component = /*#__PURE__*/React.createElement(Dialog, props);
  return portal ? withPortal(Component) : Component;
};

const Dialog = _ref2 => {
  let {
    title,
    showClose,
    onClickOutside,
    children,
    visible,
    position,
    fullScreen,
    type,
    titleStyle,
    ruleSize,
    bgRule,
    showHorizontalRule
  } = _ref2,
      props = _objectWithoutPropertiesLoose(_ref2, ["title", "showClose", "onClickOutside", "children", "visible", "position", "fullScreen", "type", "titleStyle", "ruleSize", "bgRule", "showHorizontalRule"]);

  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = visible ? 'hidden' : originalStyle;
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [visible]);
  return /*#__PURE__*/React.createElement(Container, {
    position: position,
    visible: visible,
    fullScreen: fullScreen,
    "data-testid": "dialog"
  }, /*#__PURE__*/React.createElement(Overlay, {
    onClick: onClickOutside,
    role: "dialog",
    "data-testid": "dialog-overlay"
  }), /*#__PURE__*/React.createElement(Paper, _extends({
    position: position,
    "data-testid": "dialog-content",
    type: type,
    fullScreen: fullScreen
  }, props), /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(ContentHeader, null, title && /*#__PURE__*/React.createElement(Title, {
    titleStyle: titleStyle,
    "data-testid": "dialog-title"
  }, title), showClose && /*#__PURE__*/React.createElement(CloseComponent, null, /*#__PURE__*/React.createElement(Close, {
    color: "#999",
    "aria-label": "Close",
    onClick: onClickOutside,
    "data-testid": "dialog-close"
  }))), showHorizontalRule && /*#__PURE__*/React.createElement(HorizontalRule, {
    size: ruleSize,
    bg: bgRule,
    "data-testid": "horizontal-rule"
  })), children));
};

Dialog.defaultProps = {
  children: undefined,
  title: undefined,
  fullScreen: false,
  position: 'bottom',
  type: 'dialog',
  showClose: false,
  titleStyle: {},
  visible: true,
  ruleSize: 1,
  bgRule: 'border.light',
  showHorizontalRule: false
};
process.env.NODE_ENV !== "production" ? Dialog.propTypes = {
  title: node,
  visible: bool,
  showClose: bool,
  children: node,
  onClickOutside: func.isRequired,
  fullScreen: bool,
  titleStyle: shape({}),
  position: oneOf(['top', 'center', 'bottom']),
  type: oneOf(['dialog', 'alert', 'responsive', 'full']),
  ruleSize: number,
  bgRule: string,
  showHorizontalRule: bool
} : void 0;
export default DialogComp;